<template>
  <div class="free-practice-pairs-root">
    <section class="paris-row" v-for="(leftItem, numberIndex) in chooseList" :key="leftItem?.id">
      <div class="common-item left-item" :class="{ wrongItem: leftItem?.active == 'red' }">
        <div v-if="questionKey == 'Sound'" @click="clickSound(leftItem)">
          <MultiSound
            :soundUrl="leftItem?.tts_url"
            :playing="leftItem.fatherPlayStatus"
            :unload.sync="leftItem.unload"
            :id="leftItem.id + ''"
            :loading="leftItem.loading"
            :percent="leftItem.percent"
          ></MultiSound>
        </div>

        <div v-else class="check-text">{{ leftItem[optionContentKey] }}</div>
        <div class="circle-outer outer-left" @click="clickItem('left', leftItem)">
          <div
            class="common-circle left-circle"
            :id="leftItem?.index"
            :class="[leftItem?.active]"
          ></div>
        </div>
      </div>

      <!-- rightItem == optionList[numberIndex] -->
      <div
        class="common-item right-item"
        :class="{ wrongItem: optionList[numberIndex]?.active == 'red' }"
      >
        <div v-if="answerKey == 'Sound'" @click="clickSound(optionList[numberIndex])">
          <MultiSound
            :soundUrl="optionList[numberIndex]?.tts_url"
            :playing="optionList[numberIndex].fatherPlayStatus"
            :unload.sync="optionList[numberIndex].unload"
            :id="optionList[numberIndex].id + ''"
            :loading="optionList[numberIndex].loading"
            :percent="optionList[numberIndex].percent"
          ></MultiSound>
        </div>

        <div v-else class="check-text">{{ optionList[numberIndex][chooseContentKey] }}</div>
        <div class="circle-outer outer-right" @click="clickItem('right', optionList[numberIndex])">
          <div
            class="common-circle right-circle"
            :id="optionList[numberIndex]?.index"
            :class="[optionList[numberIndex]?.active]"
          ></div>
        </div>
      </div>
    </section>
    <div
      class="pair-line"
      v-for="line in chooseList"
      :key="line?.index"
      :id="'line' + line?.index"
    ></div>
  </div>
</template>

<script>
import MultiSound from './player'
const colorObj = {
  grey: '#696974',
  green: '#39B38E',
  red: '#B33939',
}

export default {
  props: {
    questionKey: {
      type: String,
      default: 'Meaning',
    },
    answerKey: {
      type: String,
      default: 'Sound',
    },
    currentItem: {
      type: Object,
      default: () => {},
    },
    pairsUserAnswer: {
      type: Boolean,
      default: true,
    },
    pairsCheckedAnswer: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    currentItem() {
      this.initalPageData()
      this.initialDom()
      this.drawLine([])
    },
    pairsUserAnswer() {
      console.log('pairsUserAnswer', this.pairsUserAnswer)
      if (this.pairsCheckedAnswer && this.pairsUserAnswer) {
        // 展示用户答案，并且判断是否正确
        this.checkAnswer()
        this.drawLine(this.userAnswer)
        this.setactiveCircle(this.userAnswer)
      } else if (this.pairsCheckedAnswer && !this.pairsUserAnswer) {
        // 展示正确答案
        this.drawLine(this.rightAnswer)
        this.setactiveCircle(this.rightAnswer)
      }
    },
    pairsCheckedAnswer() {
      console.log('pairsCheckedAnswer', this.pairsCheckedAnswer)
      if (this.pairsCheckedAnswer && this.pairsUserAnswer) {
        // 展示用户答案，并且判断是否正确
        this.checkAnswer()
        this.drawLine(this.userAnswer)
        this.setactiveCircle(this.userAnswer)
      } else if (this.pairsCheckedAnswer && !this.pairsUserAnswer) {
        // 展示正确答案
        this.drawLine(this.rightAnswer)
        this.setactiveCircle(this.rightAnswer)
      }
    },
  },
  computed: {
    optionContentKey() {
      switch (this.questionKey) {
        case 'Meaning':
          return 'translation'
        case 'Sound':
          return 'tts_url'
        case 'Characters':
          return 'characters'
        case 'Pinyin':
          return 'pinyin'
        default:
          return ''
      }
    },
    chooseContentKey() {
      switch (this.answerKey) {
        case 'Meaning':
          return 'translation'
        case 'Sound':
          return 'tts_url'
        case 'Characters':
          return 'characters'
        case 'Pinyin':
          return 'pinyin'
        default:
          return ''
      }
    },
  },
  data() {
    return {
      lastStop: null, // left || right
      tempAnswerItem: ['', ''], // 最近一次答案，成对以后存入userAnswer
      userAnswer: [], // 用户答案{ activeColor: '', lineArr: [], },
      rightAnswer: [], // 正确答案
      chooseList: [], // 左侧选项
      optionList: [], // 右侧选项
      choosePosition: {}, // 左侧选项原点的位置信息；
      optionPosition: {}, // 右侧选项的原点的位置信息
      lineDomMap: {}, // 存放linedom信息，以左侧选项为基点；
      dialogPosition: null,
    }
  },
  methods: {
    //比对答案，错误标红
    checkAnswer() {
      this.userAnswer.forEach((userItem) => {
        let leftIndex = userItem.lineArr[0]
        let correctObj = this.rightAnswer.find((correctItem) => correctItem.lineArr[0] == leftIndex)
        if (correctObj.lineArr[1] != userItem.lineArr[1]) {
          userItem.activeColor = 'red'
        } else {
          this.correctCount++
        }
      })
    },
    // 点击选项 left--点击左边||right-- 点击右边
    clickItem(direction, item) {
      if (this.pairsCheckedAnswer) {
        return
      }
      // 上一次点击位置被清空或上一次点击位置与本次为同侧，只存入数据；
      if (!this.lastStop || this.lastStop == direction) {
        let valIndex = direction == 'left' ? 0 : 1
        this.tempAnswerItem[valIndex] = item.index
        this.lastStop = direction
      } else {
        // 与上次点击未异侧，则画线
        // 数据存入待写入数组
        let valIndex = direction == 'left' ? 0 : 1
        this.tempAnswerItem[valIndex] = item.index
        // 与待写入数据有重复，删除答案项
        for (var i = this.userAnswer.length - 1; i >= 0; i--) {
          //当前选中任一点与之前的线重复，则上一次连线删除
          if (
            this.userAnswer[i].lineArr[0] == this.tempAnswerItem[0] ||
            this.userAnswer[i].lineArr[1] == this.tempAnswerItem[1]
          ) {
            this.userAnswer.splice(i, 1)
          }
        }
        // 数据写入答案
        this.userAnswer.push({
          activeColor: 'green',
          lineArr: this.tempAnswerItem,
        })

        // 清空待写入状态
        this.tempAnswerItem = ['', '']
        this.lastStop = null
        // 画线
        this.drawLine(this.userAnswer)
        // 父级传递答案
        this.$emit('emitUserAnswer', this.userAnswer)
      }
      // 画点
      this.setactiveCircle(this.userAnswer)
    },
    // 圆点状态设置
    setactiveCircle(answerList) {
      let arrList = [this.chooseList, this.optionList]
      arrList.map((chooseList, numberIndex) => {
        //左右选项全量循环
        chooseList.forEach((chooseItem) => {
          // 如果作答列表包含当前选项，赋值为作答状态
          let lineObj = answerList.find(
            (lineItem) => lineItem.lineArr[numberIndex] == chooseItem.index
          )
          if (lineObj) {
            chooseItem.active = lineObj.activeColor
          } else {
            chooseItem.active = 'grey'
          }
          // 如果暂存答案包含当前选项，赋值为选中，绿色
          if (
            this.tempAnswerItem[numberIndex] &&
            this.tempAnswerItem[numberIndex] == chooseItem.index
          ) {
            chooseItem.active = 'green'
          }
        })
      })
    },
    // 全量画线
    drawLine(answerList) {
      for (let lineId in this.lineDomMap) {
        let lineObj = answerList.find((lineItem) => lineItem.lineArr[0] == lineId)
        let linedom = this.lineDomMap[lineId]

        if (lineObj) {
          let startId = lineObj.lineArr[0]
          let endId = lineObj.lineArr[1]
          let startDom = this.choosePosition[startId]
          let endDom = this.optionPosition[endId]
          const w = endDom.left - startDom.left
          const h = endDom.top - startDom.top

          linedom.style.width = Math.pow(w * w + h * h, 0.5) + 'px'
          linedom.style.transform = `rotate(${(Math.atan(h / w) * 180) / Math.PI}deg)`
          linedom.style.transformOrigin = '0 0'
          linedom.style.left = startDom.left - this.dialogPosition.left + 10 + 'px'
          linedom.style.top = startDom.top - this.dialogPosition.top + 10 + 'px'
          linedom.style.display = 'block'
          linedom.style.background = colorObj[lineObj.activeColor]
        } else {
          linedom.style.display = 'none'
        }
      }
    },
    getDomRect() {
      // 获取左侧所有圆点位置，右侧圆点位置，顶层容器位置
      let leftDoms = document.querySelectorAll('.left-circle')
      for (let i = 0; i < leftDoms.length; i++) {
        let index = leftDoms[i].id
        this.choosePosition[index] = leftDoms[i].getBoundingClientRect()
      }

      let rightDoms = document.querySelectorAll('.right-circle')
      for (let i = 0; i < rightDoms.length; i++) {
        let index = rightDoms[i].id
        this.optionPosition[index] = rightDoms[i].getBoundingClientRect()
      }
      const dialogDom = document.querySelector('.free-practice-pairs-root')
      this.dialogPosition = dialogDom.getBoundingClientRect()
    },
    initialDom() {
      this.$nextTick(() => {
        this.getDomRect()
        // 线dom的获取
        let lineDoms = document.querySelectorAll('.pair-line')
        for (let i = 0; i < lineDoms.length; i++) {
          let index = lineDoms[i].id.replace(/line/, '')
          this.lineDomMap[index] = lineDoms[i]
        }
      })
    },
    //初始化页面数据-进入页面||数据源切换
    initalPageData() {
      this.rightAnswer = []
      this.userAnswer = []
      this.chooseList = []
      this.optionList = []
      this.currentItem.right_answer.forEach((item) => {
        let tempArr = item.split('-')
        this.rightAnswer.push({
          activeColor: 'green',
          lineArr: tempArr,
        })
      })
      let handleList = [
        {
          originList: this.currentItem.choose,
          newList: this.chooseList,
          typeKey: this.questionKey,
        },
        {
          originList: this.currentItem.option,
          newList: this.optionList,
          typeKey: this.answerKey,
        },
      ]
      handleList.forEach((listObj) => {
        listObj.originList.forEach((optionItem) => {
          let newValue = {
            active: 'grey',
          }
          if (listObj.typeKey == 'Sound') {
            newValue.fatherPlayStatus = false
            newValue.unload = false
            newValue.percent = '0'
            newValue.loading = false
          }
          let obj = Object.assign(newValue, optionItem)
          listObj.newList.push(obj)
        })
      })
    },
    onStep(clickItem) {
      let seek = 0
      try {
        seek = this.$player.sound.seek()
      } catch (e) {
        console.log(e)
      }
      clickItem.percent = ((seek / this.$player.sound.duration()) * 100).toFixed(1)

      if (clickItem.fatherPlayStatus) {
        this.animationId = requestAnimationFrame(() => {
          this.onStep(clickItem)
        })
      }
    },
    clickSound(clickItem) {
      if (clickItem.loading) {
        return
      }
      if (!clickItem.fatherPlayStatus) {
        let arr = this.questionKey == 'Sound' ? this.chooseList : this.optionList
        arr.forEach((item) => {
          if (item.tts_url != clickItem.tts_url) {
            item.fatherPlayStatus = false
            item.unload = true
            item.loading = false
            item.percent = '0'
          }
        })
      }

      // 1. 同一文件-
      if (clickItem.tts_url == this.$player.file) {
        if (clickItem.fatherPlayStatus) {
          // 播放中-暂停
          this.$player.sound.pause()
          clickItem.fatherPlayStatus = false
          clickItem.loading = false
        } else {
          // 未播放-播放
          clickItem.fatherPlayStatus = true
          this.$player.sound.play()
          this.onStep(clickItem)
        }
      } else {
        clickItem.loading = true
        this.$player.play(clickItem.tts_url, '', {}, false, false, false)

        this.$player.onloaded = (e) => {
          clickItem.loading = false
          clickItem.fatherPlayStatus = true
          this.onStep(clickItem)
        }
        this.$player.onended = () => {
          console.log('onended change')
          clickItem.fatherPlayStatus = false
        }
        this.$player.onpaused = () => {
          clickItem.fatherPlayStatus = false
          clickItem.loading = false
        }
        this.$player.onUnload = () => {
          clickItem.fatherPlayStatus = false
          clickItem.loading = false
        }
        this.$player.onloaderrored = () => {
          clickItem.fatherPlayStatus = false
          clickItem.loading = false
        }
      }
    },
  },
  mounted() {
    this.initalPageData()
    this.initialDom()
    window.addEventListener('resize', this.getDomRect)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getDomRect)
  },
  components: {
    MultiSound,
  },
}
</script>

<style lang="scss" scoped>
.free-practice-pairs-root {
  display: flex;
  // justify-content: space-between;
  margin-top: 60px;
  position: relative;
  flex-direction: column;
  .paris-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.common-item {
  width: 280px;
  min-height: 48px;
  border: 1px solid #e7e7ed;
  font-size: 16px;
  color: #2c2f46;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  border-radius: 2px;
  padding: 5px 0 5px 16px;
  position: relative;
  word-break: break-word;
  .check-text {
    width: 220px;
    word-break: break-word;
  }
}
.wrongItem {
  border-color: #b33939 !important;
}

.circle-outer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.outer-left {
  right: 0px;
}
.outer-right {
  left: 0px;
}
.circle-outer:hover {
  background: rgba(0, 0, 0, 0.04);
}
.common-circle {
  width: 20px;
  height: 20px;
  border: 2px solid #696974;
  cursor: pointer;
  border-radius: 50%;
  position: relative;
}

.common-circle::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  top: 3px;
  left: 3px;
  transform: scale(0);
  transition: transform 150ms cubic-bezier(0.4, 0, 1, 1) 0ms;
}
.right-item {
  padding-left: 48px;
}
.activeItem {
  border-color: #39b38e !important;
  background-image: radial-gradient(circle, #39b38e 45%, transparent 46%, transparent 0);
}
.green {
  border-color: #39b38e !important;
}
.green.common-circle::after {
  background: #39b38e !important;
  transform: scale(1);
  transition: 150ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.grey {
  border-color: #696974 !important;
}
.red {
  border-color: #b33939 !important;
}
.red.common-circle::after {
  background: #b33939 !important;
  transform: scale(1);
  transition: 150ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.pair-line {
  position: absolute;
  height: 3px;
  z-index: 10;
}
</style>
